export class AppConsts {
    public static CUSTOMER = 'Customer';
    public static SUPPLIER = 'Supplier';
    public static VEHICLE = 'Vehicle';
    public static ITEM = 'Item';
}
